import { Box, Typography, Button } from '@mui/material';
import { BusinessOutlined as BusinessIcon } from '@mui/icons-material';

interface EmptyProfilesStateProps {
  onCreateProfile: () => void;
}

const EmptyProfilesState: React.FC<EmptyProfilesStateProps> = ({ onCreateProfile }) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      px: 4,
      textAlign: 'center',
    }}>
      <Box sx={{
        mb: 3,
        p: 2,
        borderRadius: '50%',
        backgroundColor: 'action.hover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <BusinessIcon sx={{ 
          fontSize: 48, 
          color: 'text.secondary'
        }} />
      </Box>
      
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
        No Business Profiles Yet
      </Typography>
      
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        Create your first business profile to start generating personalized content for your business
      </Typography>
      
      <Button
        variant="contained"
        size="large"
        startIcon={<BusinessIcon />}
        onClick={onCreateProfile}
        sx={{ minWidth: 200 }}
      >
        Create Your First Profile
      </Button>
    </Box>
  );
};

export default EmptyProfilesState;
